import { useFiltersContext } from '@/context'
import { ScheduledCommunicationTemplatesQueries } from '@/graphql/queries/scheduledCommunicationTemplates.queries'
import { ScheduledCommunicationTemplateList } from '@/types/ScheduledCommunicationTemplate'

import { useGraphql } from '../useGraphql'

const useScheduledCommunicationTemplates = () => {
  const [{ marketSegmentFilter }] = useFiltersContext()

  return useGraphql<{ scheduledCommunicationTemplates: ScheduledCommunicationTemplateList[] }>(
    ScheduledCommunicationTemplatesQueries.QUERY_KEY,
    ScheduledCommunicationTemplatesQueries.getScheduledCommunicationTemplates(),
    {
      filter: {
        marketSegmentIds:
          marketSegmentFilter.marketSegmentIds && marketSegmentFilter.marketSegmentIds.length > 0
            ? marketSegmentFilter.marketSegmentIds
            : undefined,
      },
    },
  )
}

export default useScheduledCommunicationTemplates
